import SessionTabs from '../../utils/session-tabs';
import WishlistHelper from '../../utils/wishlist-helper';
import FormField from './field';

export default class CreateWishlist extends FormField {
    constructor(parent, el) {
        super(parent, el);
        this.shareInput = this.el.querySelector('.share-input');
        this.wishlistInput = this.el.querySelector('.wishlist-input');
        this.loader = this.el.querySelector('.create-wishlist-loader');
        this.copyButton = this.el.querySelector('.copy-button');
        this.copyButtonLabel = this.copyButton.querySelector('.copy-label');
        this.copyButtonDefault = this.copyButtonLabel.innerText;
        this.bind();
        this.init();
    }

    async init() {
        await SessionTabs.share('ma2-checkout');
        this.populate();
    }

    bind() {
        this.parent.addEventListener('onSuccess', () => WishlistHelper.removeData());
        this.copyButton.addEventListener('click', (e) => this.copyToClipboard(e));
    }

    async populate() {
        this.showLoader();
        const data = await WishlistHelper.create(true);
        if(data) {
            this.shareInput.value = data.shareCode || '';
            this.wishlistInput.value = data.wishlistId || '';
        }
        this.update();
        this.hideLoader();
    }

   
    copyToClipboard(e) {
        e.preventDefault();
        navigator.clipboard.writeText(this.shareInput?.value);
        this.copyButtonLabel.innerText = this.copyButton.dataset.copiedLabel;

        setTimeout(() => {
            this.copyButtonLabel.innerText = this.copyButtonDefault;
        }, 5000);
    }

    showLoader() {
        this.loader.classList.remove('hide');
    }

    hideLoader() {
        this.loader.classList.add('hide');
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_create_wishlist');
    }
}
